import PropTypes from 'prop-types'
import styled from 'styled-components'

import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import ChartContainer from 'components/Shared/charts/Chart'

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  position: relative;
  border-radius: 3px;
  background-color: #FFFFFF;
  width: 100%;
`

const Title = styled.div`
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
  padding: 16px 0 10px 24px;
  color: ${colors.secondary20};
`

const ChartWrapper = styled.div`
  flex: 1;
`

const TicketStatusesChart = ({
  userTimeZoneAbbr, userTimeFormat24, chartType,
  ticketStatuses, isFetching,
}) => {
  const { t } = useTranslation()

  const chartConfig = {
    type: chartType || 'spline',
    displayTimezone: userTimeZoneAbbr,
    timeFormat24: userTimeFormat24,
  }

  if (!ticketStatuses) {
    return null
  }

  return (
    <StyledWrapper data-test='ticket-statuses-chart'>
      <LoadingIndicator loading={isFetching} small />
      <Title>{t('dashboardPage.createdClosedChart')}</Title>
      <ChartWrapper>
        <ChartContainer config={chartConfig} data={ticketStatuses} />
      </ChartWrapper>
    </StyledWrapper>
  )
}

TicketStatusesChart.propTypes = {
  userTimeZoneAbbr: PropTypes.string,
  userTimeFormat24: PropTypes.bool,
  chartType: PropTypes.string,
  ticketStatuses: PropTypes.array,
  isFetching: PropTypes.bool,
}

export default TicketStatusesChart
